import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArchiveIcon = ({ color, ...rest }: { color?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorTextSecondary;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" {...rest}>
      <path
        fill={currentColor}
        fillRule="evenodd"
        d="M5.012 6l-2.025 4.016h2.19C5.592 11.173 6.7 12 8 12s2.407-.827 2.824-1.984h2.212L11.011 6h1.47c.34 0 .65.193.8.498l1.629 3.333c.06.122.09.255.09.39v3.89c0 .491-.398.889-.889.889H1.89C1.398 15 1 14.602 1 14.111v-3.878c0-.143.034-.283.1-.41L2.836 6.48c.153-.294.457-.479.789-.479h1.387zm4.991-4.992v3H12L8 7 4 4.008h2.01v-3h3.993z"
      />
    </svg>
  );
};

export default ArchiveIcon;
